import { render, staticRenderFns } from "./PayslipActions.vue?vue&type=template&id=2e7c3b4f&scoped=true"
import script from "./PayslipActions.vue?vue&type=script&lang=js"
export * from "./PayslipActions.vue?vue&type=script&lang=js"
import style0 from "./PayslipActions.vue?vue&type=style&index=0&id=2e7c3b4f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7c3b4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e7c3b4f')) {
      api.createRecord('2e7c3b4f', component.options)
    } else {
      api.reload('2e7c3b4f', component.options)
    }
    module.hot.accept("./PayslipActions.vue?vue&type=template&id=2e7c3b4f&scoped=true", function () {
      api.rerender('2e7c3b4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payslips/PayslipActions.vue"
export default component.exports